import PropTypes from 'prop-types';

import { promosShape } from 'components/InfoCenter/InfoCenter.config';

import PromoCardsCta from '../PromoCardsCta/PromoCardsCta';
import PromoCardsTitle from '../PromoCardsTitle/PromoCardsTitle';
import Container from '../Container/Container';
import PromoCard from '../Promo/PromoCard';
import Text from '../Text/Text';

import { rootBaseCss, titleBaseCss, promosBaseCss } from './PromoCards.style';

function PromoCards({ className, inRichText, promos }) {
  return (
    <Container css={rootBaseCss} className={className}>
      {/* Title */}
      {promos.title && inRichText ? (
        <Text fontSize={2.4} fontWeight={500}>
          {promos.title}
        </Text>
      ) : (
        <PromoCardsTitle text={promos.title} css={titleBaseCss} />
      )}

      {/* Call to action */}
      {!promos.removeCta && promos.ctaLinkHref && (
        <PromoCardsCta
          text={promos.ctaText}
          linkAs={promos.ctaLinkAs}
          linkHref={promos.ctaLinkHref}
        />
      )}

      {/* Promos */}
      <div css={promosBaseCss}>
        {promos.articles.map(article => (
          <PromoCard key={article.slug} {...article} />
        ))}
      </div>
    </Container>
  );
}

PromoCards.propTypes = {
  className: PropTypes.string,
  /** Determine if the promos are being rendered inside rich text content */
  inRichText: PropTypes.bool,
  promos: PropTypes.shape(promosShape),
};

export default PromoCards;
